import { FLEET_TOPIC, fleetQuery, fleetSnapshot, visibleFleetIds, mergeFleetRows } from '@/runtime/fleet-observed'
import { createDeviceStatusFeed } from '@/runtime/device-status-feed'
import { queryFleetObserved } from '@/api/fleet-observed'
import { createRequestCancellation, readStoredToken } from '@/api/http'
import { isStaticDataPreview, readonlyDeviceStream, sharedReadOptions } from '@/runtime/shared-view'
import { selectedProductId } from './model'

let serial = 0
export default {
  data: () => ({ liveError: '' }),
  computed: {
    canObserveFleet () {
      const host = this.contain
      return this.platform && !this.awaitingPageProduct && !host.isTemplateEditing && !host.isComponentTemplateEditing &&
        !host.isTemplatePreview && !host.resourceCoverReadonly && !(host.obj && host.obj.templatePreview) &&
        !isStaticDataPreview(host) && (!host.isSharedView || host.isSharedDataView)
    },
    liveIdentity () {
      const host = this.contain
      return JSON.stringify([this.canObserveFleet, this.requestKey, host.activePageId, host.generation, host.shareUserId,
        !!host.menuFlag, !!host.isPreview, !!host.liveProjectPreview, !!host.isSharedView, !!host.isSharedDataView,
        host.isSharedView ? '' : typeof readStoredToken === 'function' && typeof localStorage !== 'undefined' && readStoredToken()])
    },
    liveRowsKey () { return JSON.stringify(this.platformRows.map(row => [row.id, row.productId])) }
  },
  watch: {
    liveIdentity () { this.releaseLive(); this.scheduleLive() },
    liveRowsKey () { this.scheduleLive() },
    'contain.sharedReadClient' () { this.releaseLive(); this.scheduleLive() },
    loading (value) { if (!value) this.scheduleLive() }
  },
  mounted () { this._liveMounted = true; this.scheduleLive() },
  beforeDestroy () { this._liveMounted = false; this.releaseLive() },
  methods: {
    releaseLive () {
      this._liveGeneration = (this._liveGeneration || 0) + 1
      clearTimeout(this._liveViewTimer); clearTimeout(this._liveRetry)
      if (this._liveFeed) this._liveFeed.close()
      if (this._liveRequest) this._liveRequest.cancel()
      this._liveFeed = null; this._liveRequest = null; this._liveKey = ''; this._liveReadClient = null
      this.liveError = ''
    },
    scheduleLive () {
      clearTimeout(this._liveViewTimer)
      if (!this._liveMounted || this._disposed) return
      this._liveViewTimer = setTimeout(() => this.$nextTick(() => this.syncLive()), 100)
    },
    syncLive () {
      if (!this._liveMounted || this._disposed) return
      if (!this.canObserveFleet || !this.initialized) { this.releaseLive(); return }
      if (this.loading) return
      const ids = visibleFleetIds(this.$refs.scroll, this.model.rows)
      if (!ids.length) { const error = this.liveError; this.releaseLive(); this.liveError = error; return }
      let query
      try {
        const host = this.contain
        query = fleetQuery({ kind: this.kind, ids,
          ...(this.kind === 'device' && this.option.productScope !== 'all' ? { productId: selectedProductId(this.option, host.navigationContext || {}, !!host.menuFlag) } : {}),
          ...(host.isSharedView ? { pageId: host.activePageId, componentId: String(this.index) } : {}) })
      } catch (error) { this.releaseLive(); this.liveError = error.message; return }
      const key = JSON.stringify([this.liveIdentity, query])
      if (key === this._liveKey) return
      this.releaseLive(); this._liveKey = key
      const host = this.contain, generation = this._liveGeneration, identity = this.liveIdentity
      this._liveReadClient = host.sharedReadClient
      const current = () => this._liveMounted && !this._disposed && this.canObserveFleet && generation === this._liveGeneration &&
        identity === this.liveIdentity && this._liveReadClient === host.sharedReadClient && (!host.isSharedView || host.sharedDataCurrent())
      try {
        const request = this._liveRequest = createRequestCancellation()
        const options = sharedReadOptions(host, { cancelToken: request.token })
        let stream
        try { stream = readonlyDeviceStream(host, 'fleet-' + Date.now() + '-' + (++serial), FLEET_TOPIC, query) }
        catch (error) { stream = { subscribe (next, failed) { failed(error); return { unsubscribe () {} } } } }
        this._liveFeed = createDeviceStatusFeed({ stream, validate: frame => fleetSnapshot(frame, query),
          snapshot: async () => {
            const response = await queryFleetObserved(query, options), body = response && response.data
            if (!body || body.success === false || body.status && body.status !== 200 || !body.result) throw Object.assign(new Error(body && body.message || '列表实时数据读取失败'), { status: body && body.status })
            return body.result
          },
          changed: frame => {
            if (!current()) return
            if (!frame) return // 权限拒绝在status分支清理；重连期间保留最近成功值。
            const before = this.platformRows.length
            this.platformRows = mergeFleetRows(this.platformRows, frame)
            this.pageTotal = Math.max(0, this.pageTotal - (before - this.platformRows.length))
            this.statsError = false
          },
          status: (state, message, cause) => {
            if (!current()) return
            this.liveError = state === 'error' ? message || '实时数据暂未更新' : ''
            if (state === 'ready') { this._liveAttempts = 0; clearTimeout(this._liveRetry) }
            if (state !== 'error') return
            const status = Number(cause && cause.status)
            if ([401, 403].includes(status)) { this.platformRows = []; this.pageTotal = 0; return }
            if ([400, 404].includes(status)) return
            const delay = Math.min(30000, 1000 * Math.pow(2, this._liveAttempts || 0))
            this._liveAttempts = (this._liveAttempts || 0) + 1
            clearTimeout(this._liveRetry)
            this._liveRetry = setTimeout(() => { if (current()) this.retryLive() }, delay)
          }
        })
      } catch (error) { if (current()) this.liveError = error.message || '实时数据暂未更新' }
    },
    retryLive () { if (!this.platformRows.length && this.liveError) return this.reload(); this.releaseLive(); this.scheduleLive() }
  }
}
